import { IconButton, InputAdornment, TextField } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface FilterFieldProps {
  searched: string;
  handleInput: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  cancelSearch: () => void;
  onFocus?: () => void;
}

const FilterField = ({ searched, handleInput, cancelSearch, onFocus }: FilterFieldProps) => {
  const { t } = useTranslation();

  return (
    <TextField
      id="filter-search"
      size="small"
      variant="outlined"
      value={searched}
      placeholder={t('filterField.filter', 'Filter')}
      onChange={handleInput}
      onFocus={onFocus}
      sx={(theme) => ({
        maxWidth: 210,
        '& .MuiOutlinedInput-root': {
          borderRadius: 20,
          height: 32,
          bgcolor: theme.vars?.palette?.action?.selected,
          '& fieldset': {
            borderColor: 'transparent',
          },
          '&:hover fieldset': {
            borderColor: theme.vars?.palette?.divider,
          },
          '&.Mui-focused fieldset': {
            borderColor: theme.vars?.palette?.primary?.main,
            borderWidth: 1,
          },
          '& input': {
            color: theme.vars?.palette?.text?.primary,
            '&::placeholder': {
              color: theme.vars?.palette?.text?.primary,
              opacity: 0.7,
            },
          },
          '& .MuiInputAdornment-root': {
            color: theme.vars?.palette?.text?.primary,
          },
        },
      })}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <FilterAltIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: searched != '' && (
            <InputAdornment position="end">
              <IconButton
                onClick={cancelSearch}
                size="small"
                sx={(theme) => ({
                  color: theme.vars?.palette?.text?.contrast,
                })}
              >
                <CancelIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export default FilterField;
